import { useCallback } from 'react';
import { Lesson } from '@/models/Lesson';
import { MutationHooks } from '../useLevelProgression.types';
import { useDailyQuestCompletion } from '../quest/useDailyQuestCompletion';
import { dailyQuestService } from '@/services/DailyQuestService';

/**
 * Hook for handling daily quest progression
 */
export const useDailyQuestProgression = () => {
  const { completeDailyQuestAndAwardXP } = useDailyQuestCompletion();
  
  /**
   * Complete a daily quest and award XP
   */
  const completeDailyQuest = useCallback(
    async (
      userId: string | undefined,
      selectedLesson: Lesson | null,
      totalXpGained: number,
      setShowLessonComplete: React.Dispatch<React.SetStateAction<boolean>>,
      mutations: MutationHooks,
      isPerfectLesson: boolean = false,
      handleImperfectLesson?: () => void,
      updateLessonBonus?: (isPerfect: boolean) => number
    ): Promise<number> => {
      if (!selectedLesson?.isDailyQuest) {
        // Use the standard lesson completion handler
        const { completeLessonAndAwardXP } = await import('./useLessonCompletionHandler');
        return completeLessonAndAwardXP(
          userId,
          selectedLesson,
          totalXpGained,
          setShowLessonComplete,
          mutations,
          isPerfectLesson,
          handleImperfectLesson,
          updateLessonBonus
        );
      }
      
      console.log(`🎯 [DailyQuest] Completing daily quest: ${selectedLesson.name}`);
      
      // Use the daily quest completion handler
      return completeDailyQuestAndAwardXP(
        userId,
        selectedLesson,
        totalXpGained,
        setShowLessonComplete,
        mutations,
        isPerfectLesson,
        handleImperfectLesson,
        updateLessonBonus
      );
    },
    [completeDailyQuestAndAwardXP]
  );
  
  return {
    completeDailyQuest
  };
};
